<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      :endpoint="`modems/${this.uid}/commands`"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :date="date"
    />

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <div class="mr-auto"><h1>{{ this.uid }}</h1></div>
        <filter-range-date v-model="date" class="mr-2" style="max-width: 26em;"/>
        <div class="btn-group">
          <router-link
            class="btn btn-outline-light"
            v-if="this.modem && this.modem.machine && $root.checkPermission('web_ta_modem')"
            :to="`/machines/${this.modem.machine.id}/modem`"
            v-text="`Автомат ${this.modem.machine.serial_number}`"
          />
          <div class="btn btn-outline-light" v-else-if="this.modem && this.modem.machine">
            {{`Автомат ${this.modem.machine.serial_number}`}}
          </div>
          <button type="button" class="btn btn-outline-light dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"></button>
          <div class="dropdown-menu dropdown-menu-right">
            <h6 class="dropdown-header">Отправить команду</h6>
            <btn-action class="dropdown-item" @click="() => sendCommand('inf')">inf</btn-action>
            <btn-action class="dropdown-item" @click="() => sendCommand('cfg')">cfg</btn-action>
            <btn-action class="dropdown-item" @click="() => sendCommand('eva')">eva</btn-action>
            <btn-action class="dropdown-item" @click="() => sendCommand('log')">log</btn-action>
            <btn-action class="dropdown-item" @click="() => sendCommand('jlog')">jlog</btn-action>
            <btn-action class="dropdown-item" @click="() => sendCommand('ping')">ping</btn-action>
            <btn-action class="dropdown-item" @click="() => sendCommand('reboot')">reboot</btn-action>
            <div class="dropdown-divider"></div>
            <btn-action class="dropdown-item dropdown-item-danger" @click="resetPassword">
              <font-awesome-icon icon="unlock-alt" />
              Сбросить пароль
            </btn-action>
            <div class="dropdown-divider"></div>
            <btn-action class="dropdown-item dropdown-item-danger" @click="deleteModem">
              <font-awesome-icon icon="trash-alt" />
              Удалить модем
            </btn-action>
          </div>
        </div>
        <!--<button @click="clearCommands()" class="btn btn-outline-danger ml-3">Очистить лог</button>-->
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
        @filter-change="refreshFilters"
      >
        <el-table-column type="expand">
          <template slot-scope="{row}">
            <div class="modem-command-details-expand">
              <modem-command-details :command="row"></modem-command-details>
            </div>
          </template>
        </el-table-column>
        <table-column-date/>
        <el-table-column
          prop="type"
          label="Тип"
          width="150"
          :filters="typeFilters"
          filter-placement="bottom-start"
          column-key="type"
          align="center"
        />
        <el-table-column
          prop="state"
          label="Статус"
          width="150"
          :filters="stateFilters"
          filter-placement="bottom-start"
          column-key="state"
          align="center">
          <template slot-scope="{row}">
            {{ row.state }}
            <div class="text-danger" v-if="row.error_code">Ошибка {{ row.error_code }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="data_result" label="Ответ">
          <template slot-scope="{row}">
            <pre v-if="row.data_result" class="modem-command-data-result-preview m-0"
            >{{ row.data_result.trim() }}</pre>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import moment from 'moment'
  import api from '@/api'
  import FilterRangeDate from '../../../components/filter-range-date'

  export default {
    metaInfo () {
      return {title: `Модем ${this.uid}`}
    },
    components: {FilterRangeDate},
    props: {
      uid: {},
    },
    data () {
      return {
        filtersValue: {},
        data: {},
        loading: false,
        hasMore: true,
        date: {},
        typeFilters: [
          {text: 'actrep', value: 'actrep'},
          {text: 'bin', value: 'bin'},
          {text: 'cardprg', value: 'cardprg'},
          {text: 'check', value: 'check'},
          {text: 'cfg', value: 'cfg'},
          {text: 'cfgprg', value: 'cfgprg'},
          {text: 'dsl', value: 'dsl'},
          {text: 'eva', value: 'eva'},
          {text: 'evar', value: 'evar'},
          {text: 'inf', value: 'inf'},
          {text: 'jlog', value: 'jlog'},
          {text: 'jpeg', value: 'jpeg'},
          {text: 'log', value: 'log'},
          {text: 'loglist', value: 'loglist'},
          {text: 'man', value: 'man'},
          {text: 'mic', value: 'mic'},
          {text: 'mdb', value: 'mdb'},
          {text: 'ping', value: 'ping'},
          {text: 'qrcode', value: 'qrcode'},
          {text: 'reboot', value: 'reboot'},
          {text: 'transfer', value: 'transfer'},
          {text: 'wav', value: 'wav'},
        ],
        stateFilters: [
          {value: 'ok', text: 'ok'},
          {value: 'error', text: 'error'},
          {value: 'queued', text: 'queued'},
          {value: 'placed', text: 'placed'},
          {value: 'in_progress', text: 'in_progress'},
        ],
      }
    },
    asyncComputed: {
      modem () {
        return api.get(`modems/${this.uid}`).then(({data}) => data)
      },
    },
    filters: {
      timestamp (ts) {
        return moment(ts).format('DD.MM.YYYY HH:mm:ss')
      },
    },
    methods: {
      sendCommand (type) {
        if (window.confirm(`Отправить команду ${type}?`)) {
          return api.post(`modems/${this.uid}/commands`, {
            type,
          }).then(() => {
            window.location.reload()
          })
        }
      },
      resetPassword () {
        if (window.confirm('Действительно сбросить пароль?')) {
          return api.put(`modems/${this.modem.id}/resetPassword`)
        }
      },
      deleteModem () {
        if (window.confirm('Удалить модем?')) {
          return api.put(`/modems/${this.uid}/delete`)
            .then(() => this.$router.push('/modems/deleted'))
        }
      },
      refreshFilters (event) {
        this.filtersValue = Object.assign({}, this.filtersValue, event)
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .modem-command-data-result-preview {
    @include text-overflow-lines(2);
    position: relative;
    &:after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: .6em;
      pointer-events: none;
      @include gradient-y(rgba(#fff, 0), rgba(#fff, .3));
    }
  }
  .modem-command-details-expand .modem-command-data-result {
    max-height: 29.5 * $line-height-base * 1em;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/modems/_uid/index.vue